/**
 * Represents an enumeration that can be treated as a bit field; that is, a set of flags.
 */
// tslint:disable:no-bitwise
export class FlagsEnum<T extends number> {
  /** set of flags represented as bits. */
  public value: number = 0;

  /**
   * Add a flag to set.
   * @param flag The flag to be added.
   */
  public add(flag: T): void {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    this.value = this.value | <number>(flag);
  }

  /**
   * Checks if flag is set.
   * @param flag The flag to check.
   */
  public hasFlag(flag: T): boolean {
    return (this.value & flag) === flag;
  }
}
